import { render } from "./SelfRegistration.vue?vue&type=template&id=08757132&scoped=true"
import script from "./SelfRegistration.vue?vue&type=script&lang=js"
export * from "./SelfRegistration.vue?vue&type=script&lang=js"

import "./SelfRegistration.vue?vue&type=style&index=0&id=08757132&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08757132"]])

export default __exports__